"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCatalogVideoModal = void 0;
var ui_1 = require("@aperza/ui");
var react_1 = __importStar(require("react"));
// import style from './CatalogVideoModal.module.scss';
var Modal_1 = __importDefault(require("react-bootstrap/Modal"));
var react_dom_1 = __importDefault(require("react-dom"));
var CatalogVideoModal = function () {
    var _a = __read(react_1.useState(false), 2), open = _a[0], setOpen = _a[1];
    var _b = __read(react_1.useState(), 2), youTubeUrl = _b[0], setYouTubeUrl = _b[1];
    var _c = __read(react_1.useState('CatalogPage'), 2), designType = _c[0], setDesignType = _c[1];
    var getMessage = ui_1.useReactiveMessage('CATALOG_VIDEO').getMessage;
    var onModalClose = function () {
        setOpen(false);
    };
    var subscription;
    react_1.useEffect(function () {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        subscription = getMessage().subscribe(function (message) {
            if (message) {
                setYouTubeUrl(message.video.videoUrl);
                setOpen(true);
                if (message.designType) {
                    setDesignType(message.designType);
                }
            }
        });
        var elements = document.getElementsByClassName('modal-youtube');
        if (elements && elements.length > 0) {
            elements.forEach(function (el) {
                el.addEventListener('click', function (event) {
                    var source = event.currentTarget;
                    if (source && source.dataset.youtube) {
                        event.preventDefault();
                        setYouTubeUrl(source.dataset.youtube);
                        setOpen(true);
                    }
                });
            });
        }
    }, []);
    return (react_1.default.createElement(Modal_1.default, { show: open, onHide: onModalClose, className: "modal preview-youtube fade", size: "lg", centered: true, role: "video" },
        react_1.default.createElement(Modal_1.default.Body, { className: "modal-body p-0 position-relative", style: { width: '870px', height: '490px' } },
            react_1.default.createElement("button", { className: "position-absolute close", type: "button", "data-dismiss": "modal", "aria-label": "Close", style: { top: 0, right: '-40px' }, onClick: onModalClose },
                react_1.default.createElement("span", { className: "text-white", "aria-hidden": "true" },
                    react_1.default.createElement("i", { className: "fas fa-times fa-fw" }))),
            react_1.default.createElement("div", { className: "embed-responsive h-100" },
                react_1.default.createElement("div", { className: "embed-responsive-item" },
                    react_1.default.createElement("iframe", { className: "embed-responsive-item", frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, src: youTubeUrl }))))));
};
exports.default = CatalogVideoModal;
var renderCatalogVideoModal = function () {
    var modalId = 'aperza-catalog-video-modal';
    var modal = document.getElementById(modalId);
    if (!modal) {
        var aperzaCatalogVideoModal = document.createElement('div');
        aperzaCatalogVideoModal.id = modalId;
        document.body.appendChild(aperzaCatalogVideoModal);
        react_dom_1.default.render(react_1.default.createElement(CatalogVideoModal, null), aperzaCatalogVideoModal);
    }
    else {
        console.warn("Trying to create additional modal: " + modalId);
    }
};
exports.renderCatalogVideoModal = renderCatalogVideoModal;
